import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {LoaderService} from "../loader.service";
import {USER_BALANCE_CONFIG} from "../../config/api";
import {PopupComponent} from "../../shared/popup/popup.component";

@Injectable({
  providedIn: 'root'
})
export class UserBalanceService {
  private entries = 0;
  private winnings = 0;
  private gameBalance = 0;
  private showBalanceLoader = false;

  private config = USER_BALANCE_CONFIG;

  constructor(private http: HttpClient,
              private popupComponent: PopupComponent,
              public loaderService: LoaderService) {
  }

  getBalance() {
    //this.loaderService.show();
    return this.http.post<any>(this.config.getBalance, {});
  }

  updateBalance(entries, winnings) {
    this.entries = entries;
    this.winnings = winnings;
  }

  updateGameBalance(balance) {
    this.gameBalance = balance;
  }


  getGameBalanceLoaderState() {
    return this.showBalanceLoader;
  }

  getEntries() {
    return Number(this.entries).toFixed(0);
  }

  getWinnings() {
    return Number(this.winnings).toFixed(0);
  }

  getGameBalance() {
    return this.gameBalance;
  }

  increaseBalance(amount, gameProviderId) {
    //this.loaderService.show();
    return this.http.post<any>(this.config.increaseBalance, {amount, gameProviderId});
  }

  redeem(gameProviderId, amount) {
    // this.loaderService.show();
    return this.http.post<any>(this.config.redeem, {gameProviderId, amount});
  }

  withdraw(gameProviderId, amount) {
    //this.loaderService.show();
    return this.http.post<any>(this.config.withdraw, {gameProviderId, amount});
  }

  getGameBalanceRequest(id) {
    //this.loaderService.show();
    return this.http.post<any>(this.config.getGameBalance, {id});
  }

  initGameBalanceRequest(id) {
    this.showBalanceLoader = true;
    this.getGameBalanceRequest(id).subscribe((data) => {
      try {
        if (data.status) {
          this.updateGameBalance(data.availableBalance);
        } else {
          this.popupComponent.showPopupError({text: data.message});
        }
        this.showBalanceLoader = false;
      } catch (e) {
        this.loaderService.hideAndShowTryAgain();
        this.showBalanceLoader = false;
      }
    }, () => {
      this.loaderService.hideAndShowTryAgain();
      this.showBalanceLoader = false;
    }, () => {
      this.loaderService.hide();
      this.showBalanceLoader = false;
    })
  }
}
